import { useLibraryStore } from '../library.store'
import { storeToRefs } from 'pinia'
import { AnalyticsData } from '@/tracking/analytics/analyticsTracker.ts'
import { computed, ComputedRef } from 'vue'

export function useLibraryFolderAnalytics() {
  const libraryStore = useLibraryStore()
  const {
    folderCount,
    archivedFolderCount,
    currentFolderOwner,
    currentFolderUserRole,
    currentFolderUuid,
    currentFolderContentCount
  } = storeToRefs(libraryStore)

  const getLegacyEventData: ComputedRef<AnalyticsData> = computed(() => ({
    // legacy - to deprecate in future
    student_uuid: currentFolderUuid,
    student_content_count: currentFolderContentCount,
    student_owner: currentFolderOwner,
    // new
    folder_uuid: currentFolderUuid,
    folder_content_count: currentFolderContentCount,
    folder_owner: currentFolderOwner
  }))

  // getEventData is a computed object of library folder analytics data
  // once the .value is assigned to a variable, the resulting data will stop being reactive
  const getEventData: ComputedRef<AnalyticsData> = computed(() => (getReactiveEventAttributes()))

  // getReactiveEventAttributes contains an object of reactive library folder analytics data attributes
  // the returned object can be assigned to a variable, and the attributes will remain reactive
  function getReactiveEventAttributes(): AnalyticsData {
    return {
      folder_uuid: currentFolderUuid,
      folder_count: folderCount,
      archived_folder_count: archivedFolderCount,
      folder_content_count: currentFolderContentCount,
      folder_owner: currentFolderOwner,
      user_folder_role: currentFolderUserRole
    }
  }


  return {
    getLegacyEventData,
    getEventData,
    getReactiveEventAttributes
  }
}
